import { render, staticRenderFns } from "./ModalAddCustomersAddress.vue?vue&type=template&id=50ce8015&scoped=true&"
import script from "./ModalAddCustomersAddress.vue?vue&type=script&lang=js&"
export * from "./ModalAddCustomersAddress.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddCustomersAddress.vue?vue&type=style&index=0&id=50ce8015&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ce8015",
  null
  
)

export default component.exports